
export const _EXPERT_OPINION_SECTION_TABLE = ( that ) => {
    return [{
        index: 0,
        keyTitle: '',
        keyType: 'TextArea',
        class: ['height_100', 'min_height_500'],
        parentClass : [],
        keyRange: [],
        values: undefined,
        maxLength: 2000,
        unit: that.$t('unit.char')
    }]
}